import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getIsUserSignedIn } from "@gamedev-web/gamedev-sdk-core";

import { PageType } from "../constants";
import { Programs } from "../models/programsConfig";
import { crmActions } from "../redux/actions/crmApiActions";
import { getIsInitialCrmFetchDone } from "../redux/selectors";

export const ProgramSearchParam = "program";
export const FormIdSearchParam = "form-id";
export const SubFormIdSearchParam = "sub-form-id";
export const GameConceptIdSearchParam = "game-concept-id";
export const PitchConceptIdSearchParam = "pitch-concept-id";
export const DraftSearchParam = "draft";

export const useFetchCrmData = (pageType: PageType | undefined) => {
  const dispatch = useDispatch();
  const isInitialCrmFetchDone = useSelector(getIsInitialCrmFetchDone);
  const isSigned = useSelector(getIsUserSignedIn);
  useEffect(() => {
    if (!pageType || !isSigned || isInitialCrmFetchDone) {
      return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    switch (pageType) {
      case PageType.IdXboxApplication:
        dispatch(
          crmActions.fetchCrmData.start(
            pageType,
            Programs.IdXbox,
            searchParams.get(GameConceptIdSearchParam) ?? undefined,
            searchParams.get(DraftSearchParam) === "1"
          )
        );
        break;
      case PageType.PitchApplication:
        dispatch(
          crmActions.fetchCrmData.start(
            pageType,
            Programs.Pitch,
            searchParams.get(PitchConceptIdSearchParam) ?? undefined,
            searchParams.get(DraftSearchParam) === "1"
          )
        );
        break;
      case PageType.AaaApplication:
        dispatch(
          crmActions.fetchCrmData.start(
            pageType,
            Programs.Aaa,
            searchParams.get(GameConceptIdSearchParam) ?? undefined,
            searchParams.get(DraftSearchParam) === "1"
          )
        );
        break;
    }
  }, [dispatch, isInitialCrmFetchDone, isSigned, pageType]);
};
